import youcam from './youcam/routes';
import skincarepro from './skincarepro/routes';

export default [youcam, skincarepro];
